import { TrendUp, CurrencyInr, ChartLineUp, Wallet } from "@phosphor-icons/react";

const formatCurrency = (value) => {
  if (value >= 10000000) {
    return `₹${(value / 10000000).toFixed(2)} Cr`;
  } else if (value >= 100000) {
    return `₹${(value / 100000).toFixed(2)} L`;
  } else {
    return `₹${value.toLocaleString('en-IN')}`;
  }
};

export const KPICards = ({ data }) => {
  const kpis = [
    {
      icon: CurrencyInr,
      label: "Total Trail Revenue",
      value: formatCurrency(data.total_revenue),
      color: "emerald",
      testId: "kpi-total-revenue"
    },
    {
      icon: ChartLineUp,
      label: "Final AUM",
      value: formatCurrency(data.final_aum),
      color: "blue",
      testId: "kpi-final-aum"
    },
    {
      icon: Wallet,
      label: "Total Inflow",
      value: formatCurrency(data.total_inflow),
      color: "amber",
      testId: "kpi-total-inflow"
    }
  ];

  const colorMap = {
    emerald: "bg-emerald-700",
    blue: "bg-blue-600",
    amber: "bg-amber-600"
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {kpis.map((kpi, idx) => (
        <div
          key={idx}
          className="bg-white rounded-sm border border-slate-200 p-6 hover:-translate-y-1 hover:shadow-md transition-all duration-200"
          data-testid={kpi.testId}
        >
          <div className="flex items-start justify-between">
            <div className="flex-1">
              <p className="text-xs uppercase tracking-[0.2em] font-medium text-slate-500 mb-3">
                {kpi.label}
              </p>
              <p className="text-3xl font-bold font-mono tracking-tight text-slate-900">
                {kpi.value}
              </p>
            </div>
            <div className={`${colorMap[kpi.color]} w-12 h-12 rounded-sm flex items-center justify-center flex-shrink-0`}>
              <kpi.icon size={24} weight="duotone" className="text-white" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default KPICards;